var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',[_c('div',{staticClass:"noteText"},[_vm._v("\n    好遗憾，不满足活动参与条件，本活动仅限下单成功的老用户参与。\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }